import {CLEAN} from '../constants/index';

/**
 * @name cleanDataByStoreKey
 * @desc Removes redux store data from `state.gmi.data[storeKey]`
 * @param {String} dataKey
 * @param {String} storeKey
 * @returns {{type: string, dataKey: string, storeKey: string}}
 * @memberof actions
 * @example
 * dispatch(cleanDataByStoreKey('filters', 'location_policies'));
 * // will delete data at `state.gmi.data.filters.location_policies`
 */
export function cleanDataByStoreKey(dataKey, storeKey) {
  return {type: CLEAN.CLEAN_DATA_BY_STORE_KEY, dataKey, storeKey};
}

/**
 * @name cleanLocationByIdState
 * @desc Removes location data from store
 * @param {Array} [locationIds]
 * @returns {{type: string}}
 * @memberof actions
 * @example
 * // clear all locations
 * dispatch(cleanLocationByIdState());
 *
 * // clear an array of specific locations
 * dispatch(cleanLocationByIdState(['1018963']));
 */
export function cleanLocationByIdState(locationIds) {
  return {type: CLEAN.CLEAN_LOCATIONS_STATE, locationIds};
}

/**
 * @name cleanMessages
 * @param {Array} [serviceTypes]
 * @returns {{type: string, serviceTypes: *}}
 * @memberof actions
 * @example
 * // clear all
 * dispatch(cleanMessages());
 *
 * // clear service types one at a time
 * dispatch(cleanMessages(['GMA', 'SOLR']));
 *
 * // the above will set...
 * state.gmi.messages.gma = [];
 * state.gmi.messages.gma_services = {};
 * state.gmi.messages.solr = [];
 * state.gmi.messages.solr_services = [];
 */
export function cleanMessages(serviceTypes) {
  return {type: CLEAN.CLEAN_MESSAGES, serviceTypes};
}

/**
 * @name cleanSolrStateByType
 * @desc Removes solr related data from store
 * @param {Array} [endpoints]
 * @returns {{type: string, endpoints: *}}
 * @memberof actions
 * @example
 * // clean all solr state
 * dispatch(cleanSolrStateByType());
 *
 * // clean state by specific endpoints
 * const endpoints = [
 *  {key:'ALL'},
 *  {key:'COUNTRY'},
 *  {key:'COUNTRY', data:['UK']},
 *  {key:'COUNTRY_STATE'},
 *  {key:'COUNTRY_STATE', data:['US', 'NY']},
 *  {key:'HOURS'},
 *  {key:'HOURS', data:['1018963']},
 *  {key:'RENTER_AGE'},
 *  {key:'RENTER_AGE', data:['UK']},
 *  {key:'SPATIAL'},
 *  {key:'TEXT'}
 * ];
 * dispatch(cleanSolrStateByType(endpoints));
 */
export function cleanSolrStateByType(endpoints) {
  return {type: CLEAN.CLEAN_SOLR_STATE, endpoints};
}
